import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";

export default function TermsPage() {
  return (
    <>
      <SEO title="Terms of Use" description="Terms of Use for Finance Topia." url="/terms" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Terms" }]} />
        <header className="border-b-2 border-foreground pb-6 mt-4">
          <div className="overline">Legal</div>
          <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">Terms of Use</h1>
          <p className="mt-2 font-mono text-xs text-foreground/60">Last updated: {new Date().toLocaleDateString()}</p>
        </header>
        <div className="prose-article mt-10">
          <p>By accessing Finance Topia, you agree to the following terms. If you do not agree, please do not use the site.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Editorial Content Only</h2>
          <p>All content on this site is for informational and educational purposes only. It does not constitute investment, tax, legal, or financial advice. Consult a qualified fiduciary advisor before making financial decisions.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">No Warranties</h2>
          <p>Content is provided "as is". We make no warranties regarding accuracy, completeness, or timeliness. Financial data and prices may be delayed or inaccurate.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Intellectual Property</h2>
          <p>All original text, layouts, and images are the property of Finance Topia unless otherwise credited. You may share excerpts with proper attribution and a link to the original article.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Third-Party Links & Advertising</h2>
          <p>We may link to third-party sites and display third-party advertisements (including via Google AdSense). We are not responsible for the content or practices of third parties.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Finance Topia is not liable for any direct, indirect, incidental, or consequential damages arising from your use of the site.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Scrape, republish, or automate access to the site beyond ordinary browsing.</li>
            <li>Attempt to bypass rate limits, access controls, or the admin area.</li>
            <li>Redistribute our editorial content in bulk without written permission.</li>
            <li>Use our content, brand, or likeness in a way that misrepresents Finance Topia.</li>
          </ul>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">AI-Assisted Content Notice</h2>
          <p>Some or all articles on Finance Topia are drafted with the assistance of large language models (currently Claude Sonnet 4.6) and reviewed against our editorial standards before publication. This does not change the educational-only nature of the content. See our <a href="/editorial">Editorial Team</a> page for our full process.</p>

          <h2 className="font-display text-2xl font-black mt-8 mb-3">Changes</h2>
          <p>We may update these terms periodically. Continued use of the site after changes constitutes acceptance of the revised terms.</p>
        </div>
      </div>
    </>
  );
}
